import axiosClient from './axiosClient';

export const fetchWeeklyTournaments = async () => {
    try {
        const response = await axiosClient.get('/v1/tournaments/all');
        // Assuming the structure { success: true, data: [...] }
        if (response.data && response.data.success) {
            return response.data.data; // Return the array of tournaments
        } else {
            throw new Error(response.data.errors || 'Failed to fetch tournaments');
        }
    } catch (error) {
        // Re-throw the error so the component can handle it
        throw error;
    }
}; 

export const fetchEslTournaments = async () => {
    try {
        const response = await axiosClient.get('/v1/esl/tournaments/all');
        if (response.data && response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.errors || 'Failed to fetch tournaments');
        }
    } catch (error) {
        throw error;
    }
}

export const eslTournamentCheckin = async (tournamentId) => {
    try {
        const response = await axiosClient.post('/v1/esl/tournament/entry/checkin', {id: tournamentId});
        if (response.data && response.data.success) {
            return response.data;
        } else {
            throw new Error(response.data.errors || 'Failed to fetch tournaments');
        }
    } catch (error) {
        throw error;
    }
}

export const eslTournamentMatchCheckin = async (tournamentMatchId, matchRoomId) => {
    try {
        // console.log('Making match checkin request:', {
        //     endpoint: '/v1/esl/tournament/match/checkin',
        //     tournamentId: tournamentMatchId,
        //     roomId: matchRoomId
        // });
        
        const response = await axiosClient.post('/v1/esl/tournament/match/checkin', {
            tournamentId: tournamentMatchId, 
            roomId: matchRoomId
        });
        
        // console.log('Match checkin response:', response.data);
        return response.data;
    } catch (error) {
        // console.error('Match checkin error:', {
        //     status: error.response?.status,
        //     statusText: error.response?.statusText,
        //     data: error.response?.data,
        //     message: error.message
        // });
        
        if (error.response?.data) {
            return error.response.data;
        }
        
        throw error;
    }
}

export const eslTourMatchResult = async (tournamentMatchId, matchRoomId, resultFlag) => {
    try {
        const response = await axiosClient.post('/v1/esl/tournament/match/result', {tournamentId: tournamentMatchId, roomId: matchRoomId, result_flag: resultFlag});
        if (response.data && response.data.success) {
            return response.data;
        } else {
            throw new Error(response.data.errors || 'Failed to check in to the tournament');
        }
    } catch (error) {
        throw error;
    }
};

export const eslTourStats = async (tournamentId) => {
    try {
        const response = await axiosClient.post('/v1/esl/tournament/matches', {id: tournamentId});
        if(response.data && response.data.success) {
            return response.data;
        }
    } catch (e) {}
}

export const fetchTournamentById = async (tournamentId) => {
    try {
        const response = await axiosClient.post('/v1/tournament/view', { id: tournamentId });
        if (response.data && response.data.success) {
            return response.data.data[0]; // Return the first tournament object
        } else {
            throw new Error(response.data.errors || 'Failed to fetch tournament details');
        }
    } catch (error) {
        throw error;
    }
};

export const tournamentEntry = async (params) => {
    try {
        const response = await axiosClient.post('/v1/tournament/entry/checkin', params);
        if (response.data && response.data.success) {
            return response.data; // Return the response data
        } else {
            throw new Error(response.data.errors || 'Failed to check in to the tournament');
        }
    } catch (error) {
        throw error;
    }
};